<template>
  <div class="data-list">
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            label-width="110px"
            size="mini"
          >
            <el-form-item label="规则" prop="ruleValue">
              <el-input
                v-model="searchForm.ruleValue"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="匹配类型" prop="ruleType">
              <el-select v-model="searchForm.ruleType">
                <el-option  v-bind="obj" v-for="(obj,index) in ruleTypeList" :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="创建人" prop="createdName">
              <el-input
                v-model="searchForm.createdName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item label="编辑时间" prop="updatedTime">
              <el-date-picker
                class="date-input"
                size="small"
                v-model="searchForm.updatedTime"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="daterange"
                range-separator="-"
                start-placeholder="起始时间"
                end-placeholder="截至时间"
              >
              </el-date-picker>
            </el-form-item> -->
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">
              查询
            </el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="handleAddOrEdit(0)">
            新建
          </el-button>
          <!-- <el-button type="primary" size="small" @click="handleAddOrEdit(1)">
            特殊人员配置
          </el-button> -->
        </template>
        <el-table
          stripe
          v-loading="loading"
          ref="tableRef"
          border
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight"
        >
          <el-table-column  prop="ruleValue" label="规则" align="center"></el-table-column>
          <el-table-column  prop="ruleType" label="匹配类型" align="center" >
            <template slot-scope="scope">
              <span>{{scope.row.ruleType | ruleType}}</span>
            </template>
          </el-table-column>
          <el-table-column  prop="createdName" label="创建人" align="center"></el-table-column>
          <el-table-column  prop="updatedDate" label="编辑时间" align="center"></el-table-column>
          <el-table-column  label="操作"  class-name="action-column" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
    <add-dialog 
      :isNewAddPopup.sync="isNewAddPopup"
      :formItems="teacherFormItems"
      :editData.sync='editData' 
      v-if="isNewAddPopup"
      @onConfirm="onConfirm"
    >
    </add-dialog>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import addDialog from './add-dialog.vue'
import { teacherFormItems } from './config'
export default {
  name: "teacher",
  mixins: [tableMixin],
  components: {
    addDialog
  },
  data() {
    return {
      isNewAddPopup: false,
      searchForm: {
        ruleValue: '',
        ruleType: "",
        createdName: "",
        updatedTime: [],
      },
      ruleTypeList: [
        {label: '个人', value: 1},
        {label: '部门', value: 2},
        {label: '指定部门', value: 3},
      ],
      // 表格相关
      tableData: [],
      pageSize: 100,
      pageNum: 1,
      total: 0,
      filterParam: {
      },
      loading: false,
      teacherFormItems,
      editData: {
        ruleValue: '',
        ruleType: 1,
        roomId: '',
      },
      newAddType: 0
    };
  },
  methods: {
    init() {
      this.getList();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.configure
        .queryActivityConfigList(params)
          .then(({ data: { list, total } }) => {
            this.tableData = list || [];
            this.total = total;
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (key === "updatedTime" && val) {
          // this.filterParam.updateTimeEnd = val[0] || "";
          // this.filterParam.updateTimeStart = val[1] || "";
        } else if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    handleAddOrEdit(newAddType) {
      this.newAddType = newAddType
      if (newAddType == 1) {
        this.editData.ruleType = 1
      } else {
        this.editData.ruleType = ''
      }
      // if (row.roomId) {
      //   const {roomId,roomName,liveRoomId} = row
      //   this.editData = { roomId, roomName, liveRoomId, remark:''}
      // }
      this.isNewAddPopup = true
    },
    onConfirm() {
      let requset = this.newAddType == 0 ? 'saveOrUpdate' : 'setStaffTkb'
      this.$api.configure[requset](this.editData)
        .then(res => {
          this.$message({
            message: '保存成功',
            type: 'success'
          });
          this.isNewAddPopup = false
          this.init()
          this.editData ={
            ruleValue: '',
            ruleType: '',
            roomId: '',
          }
        })
    },
    handleState(row,useStatus) {
      const {liveRoomId} = row
      this.$api.configure.updateUseStatus({liveRoomId,useStatus})
        .then(res => {
          this.$notify.success({
            title: '成功',
            message: '操作成功',
          });
          this.init()
        })
    },
    handleDelete(row) {
      this.$confirm('删除后将无法恢复。请问是否删除?', '删除提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.configure.delete(row.id).then(res => {
            if (res.success) {
              this.$notify.success({
                title: '成功',
                message: '删除成功',
              });
              this.init()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    }
  },
  filters: {
    ruleType(val) {
      const map = {
        1: '个人',
        2: '部门',
        3: '指定部门'
      };
      return map[val] || '';
    }
  },
  created() {
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
.date-input
  width 220px !important
</style>
